import React, { useState, useEffect } from "react";
import DisplayImages from "../Exercises/DisplayImage";
import { Modal, Paper, TextField, Button } from "@mui/material";
import axios from "axios";
import config from "../../config";
import FileUploader3 from "../../Components/files/FileUploader3";
import { setHeaders } from "../../utils";

function ModalAttachEduFile({ isOpen, onClose, Idd }) {
  const [imagesrc, setImage] = useState("");
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);

  const initialFileList = [
    {
      FileName: "",
      FileContent: "",
      FileTitle: "",
      FileDescription: "",
      FilesAddress: "",
      FileType: "",
      isImage: false,
    },
  ];
  const [educationFilenewList, seteducationFilenewList] =
    useState(initialFileList);
  const [educationFileList, setEducationFIleList] = useState(initialFileList);

  const handleFileChange = (files) => {
    setSelectedFiles(
      files.filter(
        (value, index, self) =>
          index === self.findIndex((t) => t.path === value.path)
      )
    );
  };

  const [educationData, setEducationData] = useState({
    title: "",
    content: "",
    subTitle: "",
    subContent: "",
    educationDate: "",
    educationCategoryID: 0,
  });

  useEffect(() => {
    setSelectedFiles([]);
    seteducationFilenewList([]);
    // setEducationFIleList([]);
    setEducationData({});
    if (Idd > 0) {
      const headers = setHeaders();
      axios
        .get(config.hostname + `/api/v1/Education/${Idd}`, { headers })
        .then((res) => {
          res.status === 200 && setEducationData(res.data);
        })
        .catch((error) => {
          console.error("خطا در درخواست به API: ", error);
        });

      axios
        .get(config.hostname + `/api/v1/Education/${Idd}/EducationFiles`, {
          headers,
        })
        .then((res) => {
          if (res.status === 200) {
            const educationfilData = res.data.result;
            const formattedData = educationfilData.map((item) => ({
              KeyID: item.keyID,
              FileName: item.fileName,
              FileContent: item.fileContent,
              FileTitle: item.fileTitle,
              FileDescription: item.fileDescription,
              FilesAddress: item.filesAddress,
              FileType: item.fileType,
              isImage: item.isImage,
            }));
            seteducationFilenewList(formattedData);
          }
        })
        .catch((error) => {
          console.error("خطا در درخواست به API: ", error);
        });
    } else {
      setEducationData({
        title: "",
        content: "",
        subTitle: "",
        subContent: "",
        educationDate: "",
        educationCategoryID: 0,
      });
    }
  }, [Idd]);

  const loadFormData = () => {
    setSelectedFiles([]);
    seteducationFilenewList([]);
    setEducationFIleList([]);
    const headers = setHeaders();
    axios
      .get(config.hostname + `/api/v1/Exercise/${Idd}/EducationFiles`, {
        headers,
      })
      .then((res) => {
        if (res.status === 200) {
          const educationfilData = res.data;

          const formattedData = educationfilData.map((item) => ({
            KeyID: item.keyID,
            FileName: item.fileName,
            FileContent: item.fileContent,
            FileTitle: item.fileTitle,
            FileDescription: item.fileDescription,
            FilesAddress: item.filesAddress,
            FileType: item.fileType,
            isImage: item.isImage,
          }));
          seteducationFilenewList(formattedData);
        }
      })
      .catch((error) => {
        console.error("خطا در درخواست به API: ", error);
      });
  };

  const updateUser = async () => {
    try {
      const headers = setHeaders();

      axios.put(
        config.hostname + `/api/v1/Education`,
        {
          keyID: Idd,
          educationData,
        },
        { headers }
      );

      onClose();
    } catch (error) {
      console.error("خطا در ویرایش کاربر: ", error);
    }
  };

  const handleDeleteFile = (e, fileData, isImage) => {
    const confirmDelete = window.confirm(
      "آیا مطمئن هستید که می‌خواهید این فایل را حذف کنید؟"
    );

    if (confirmDelete) {
      const headers = setHeaders();
      axios
        .delete(
          config.hostname +
            `/api/v1/Education/${Idd}/EducationFiles/${fileData},${isImage}`,
          { headers }
        )
        .then((res) => {
          if (res.status === 200) {
            const updatedFileList = educationFilenewList.filter(
              (item) => item.KeyID !== fileData
            );
            seteducationFilenewList(updatedFileList);
          }
        })
        .catch((error) => {
          console.error("خطا در درخواست به API برای حذف فایل: ", error);
        });
    }
  };

  const insertFiles = async () => {
    setUploading(true);

    try {
      const filesData = [];
      const promises = selectedFiles.map(async (file) => {
        return new Promise((resolve) => {
          const fileData = new FormData();
          const reader = new FileReader();
          reader.onload = () => {
            const fileBytes = new Uint8Array(reader.result);
            fileData.fileName = file.name;
            fileData.fileContent = Array.from(fileBytes).join(",");
            fileData.FileTitle = "title";
            fileData.FileDescription = "description";
            fileData.FilesAddress = "";
            fileData.keyID = 0;
            fileData.FileType = file.name.split(".").pop();
            fileData.isImage =
              fileData.FileType.toUpperCase() === "JPG" ||
              fileData.FileType.toUpperCase() === "PNG" ||
              false;
            filesData.push(fileData);
            resolve();
          };
          reader.readAsArrayBuffer(file);
        });
      });

      await Promise.all(promises);

      const headers = setHeaders();

      const response = await axios.post(
        config.hostname + `/api/v1/Education/${Idd}/EducationFiles`,
        filesData,
        {
          headers,
          onUploadProgress: (progressEvent) => {
            const percentCompleted = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );

            setUploadProgress(percentCompleted);
          },
        }
      );

      loadFormData();
      onClose();
    } catch (error) {
      console.error("خطا در ویرایش کاربر: ", error);
    } finally {
      setUploading(false);
    }
  };

  return (
    <Modal className="add-education-modal" open={isOpen} onClose={onClose}>
      <Paper
        sx={{
          position: "absolute",
          display: "flex",
          flexDirection: "row",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 600,
          padding: 2,
        }}
      >
        <div style={{ flex: 1, padding: "0 10px" }}>
          <h2>افزودن فایل های آموزش</h2>
          <hr style={{ borderTop: "2px solid blue", margin: "10px 0" }} />

          <TextField
            itemID="educationTitle"
            label="عنوان آموزش"
            value={educationData.title}
            onChange={(e) =>
              setEducationData({ ...educationData, title: e.target.value })
            }
            fullWidth
            style={{ marginTop: "10px" }}
            dir="rtl"
            labelDirection="rtl"
            InputProps={{
              readOnly: true,
            }}
          />

          <TextField
            itemID="educationContent"
            label="محتوای آموزش"
            value={educationData.content}
            onChange={(e) =>
              setEducationData({ ...educationData, content: e.target.value })
            }
            fullWidth
            style={{ marginTop: "10px" }}
            dir="rtl"
            labelDirection="rtl"
            InputProps={{
              readOnly: true,
            }}
          />

          <TextField
            itemID="educationSubTitle"
            label="عنوان فرعی آموزش"
            value={educationData.subTitle}
            onChange={(e) =>
              setEducationData({ ...educationData, subTitle: e.target.value })
            }
            fullWidth
            style={{ marginTop: "10px" }}
            dir="rtl"
            labelDirection="rtl"
            InputProps={{
              readOnly: true,
            }}
          />

          <TextField
            itemID="educationSubContent"
            label="محتوای فرعی آموزش"
            value={educationData.subContent}
            onChange={(e) =>
              setEducationData({ ...educationData, subContent: e.target.value })
            }
            fullWidth
            style={{ marginTop: "10px" }}
            dir="rtl"
            labelDirection="rtl"
            InputProps={{
              readOnly: true,
            }}
          />

          <TextField
            itemID="educationDate"
            label="تاریخ آموزش"
            value={educationData.educationDate}
            onChange={(e) =>
              setEducationData({
                ...educationData,
                educationDate: e.target.value,
              })
            }
            fullWidth
            style={{ marginTop: "10px", display: "none" }}
            dir="rtl"
            labelDirection="rtl"
            InputProps={{
              readOnly: true,
            }}
          />

          <TextField
            itemID="educationCategoryID"
            label="شناسه دسته‌بندی آموزش"
            value={educationData.educationCategoryID}
            onChange={(e) =>
              setEducationData({
                ...educationData,
                educationCategoryID: e.target.value,
              })
            }
            fullWidth
            style={{ marginTop: "10px", display: "none" }}
            dir="rtl"
            labelDirection="rtl"
            InputProps={{
              readOnly: true,
            }}
          />

          <div>
            <h2> فایل های پیوست شده :</h2>
            <DisplayImages
              filesData={educationFilenewList}
              onDeleteFile={handleDeleteFile}
              prop="KeyID"
            ></DisplayImages>
          </div>
          <h2>لیست انتظار آپلود : </h2>
          <ul>
            {selectedFiles.map((file, index) => (
              <li key={index}>{file.name}</li>
            ))}
          </ul>

          <FileUploader3 onChange={handleFileChange} />
          {uploading && (
            <div style={{ color: "red", marginTop: "10px" }}>
              در حال آپلود فایل... لطفاً تا اتمام آپلود صفحه را نبندید.
              <p style={{ fontWeight: "bold" }}>
                درصد آپلود شده: {uploadProgress}
              </p>
            </div>
          )}
          <Button
            variant="contained"
            onClick={insertFiles}
            sx={{ marginTop: 2 }}
            style={{ marginBottom: "1rem" }}
          >
            افزودن فایل ها
          </Button>
        </div>
      </Paper>
    </Modal>
  );
}

export default ModalAttachEduFile;
